import React from 'react';
import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import GenerateRoutes from './routes/Routes';
import DisplayDisclaimerAndUpdateHtml from './components/displays/displaydisclaimerandupdatehtml/DisplayDisclaimerAndUpdateHtml';
import { WebsocketStore } from './stores/websocketStore/websocketStore';
import { WebSocketProvider } from './stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';

const socketStore = new WebsocketStore();
export const sendWebsocketMessage = socketStore.sendWebsocketMessage;

const AppContent = observer(() => {
  const connected = socketStore.connected;
  const isAuthenticated = socketStore.userAuthStore.isAuthenticated;
  const location = useLocation();
  const isPublicPage = location.pathname === '/ui/login' ||
                       location.pathname === '/ui/forgot-password' ||
                       location.pathname === '/ui/reset-password';

  // If on public auth pages, don't require WebSocket connection
  if (isPublicPage) {
    return <GenerateRoutes />;
  }

  // If not authenticated, allow routing (ProtectedRoute will redirect to login)
  if (!isAuthenticated) {
    return <GenerateRoutes />;
  }

  // If authenticated but WebSocket not connected, show loading
  if (!connected) {
    return <div>Connecting...</div>;
  }

  // Authenticated and connected - show full app
  return (
    <div className="App">
      <DisplayDisclaimerAndUpdateHtml />
      <GenerateRoutes />
    </div>
  );
});

const App = () => {
  return (
    <WebSocketProvider store={socketStore}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </WebSocketProvider>
  );
};

export default App;
